
let logger = (msg) => {
    return;
}

if (process.env.NODE_ENV === 'development') {
    logger = window.console.log;
}


export default logger;